import { render, staticRenderFns } from "./AppFlex.vue?vue&type=template&id=00f6f4b6&"
import script from "./AppFlex.vue?vue&type=script&lang=ts&"
export * from "./AppFlex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports